(function () {
  'use strict';

  var loading      = false;
  var scrollTimer  = null;
  var resetRequired = false;
  var resetFallback = null;

  function getSentinel()    { return document.getElementById('ds-infinite-sentinel'); }
  function getSpinner()     { return document.getElementById('ds-infinite-spinner'); }
  function getNextUrl()     { var s = getSentinel(); return s ? (s.dataset.nextUrl || null) : null; }
  function getGrid() {
    var s = getSentinel();
    return s ? document.getElementById(s.dataset.gridId || 'product-grid') : null;
  }
  function hidePagination() {
    var s = getSentinel(); if (!s) return;
    var el = document.querySelector(s.dataset.paginationSel || '.pagination-wrapper');
    if (el) el.style.display = 'none';
  }
  function sentinelIsNear() {
    var s = getSentinel(); if (!s) return false;
    return s.getBoundingClientRect().top < window.innerHeight + 50;
  }

  async function loadMore() {
    if (loading || !getNextUrl()) return;
    loading = true;

    var sp = getSpinner();
    if (sp) sp.style.display = 'flex';

    try {
      var url = getNextUrl();
      var res = await fetch(url);
      if (!res.ok) throw new Error('HTTP ' + res.status);

      var doc = new DOMParser().parseFromString(await res.text(), 'text/html');
      var s   = getSentinel();
      var gid = (s && s.dataset.gridId) || 'product-grid';
      var grid = getGrid();

      doc.querySelectorAll('#' + gid + ' > *').forEach(function (item) {
        item.classList.remove('scroll-trigger', 'animate--slide-in');
        item.style.removeProperty('--animation-order');
        if (grid) grid.appendChild(item);
      });

      var newSentinel = doc.getElementById('ds-infinite-sentinel');
      if (s) s.dataset.nextUrl = (newSentinel && newSentinel.dataset.nextUrl) || '';

    } catch (e) { /* silent â€” pagination still works as fallback */ }

    if (sp) sp.style.display = 'none';
    loading = false;

    // Block the next load until sentinel leaves the viewport zone.
    // This prevents chain-loading when layout hasn't fully settled yet.
    // The 2 s fallback auto-clears in case images are very slow to load.
    resetRequired = true;
    clearTimeout(resetFallback);
    resetFallback = setTimeout(function () { resetRequired = false; }, 2000);
  }

  function checkScroll() {
    if (loading || !getNextUrl()) return;
    var near = sentinelIsNear();

    if (resetRequired) {
      // Wait for sentinel to scroll out of the near-zone before allowing next load
      if (!near) { resetRequired = false; clearTimeout(resetFallback); }
      return;
    }

    if (near) loadMore();
  }

  function onScroll() {
    if (scrollTimer) return;
    scrollTimer = setTimeout(function () { scrollTimer = null; checkScroll(); }, 100);
  }

  function init() {
    var s = getSentinel();
    if (!s || !getNextUrl()) return;

    hidePagination();
    window.addEventListener('scroll', onScroll, { passive: true });

    // Re-init after AJAX filter updates (main-collection-product-grid template)
    var container = document.getElementById('ProductGridContainer');
    if (container) {
      new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          if (muts[i].addedNodes.length) {
            setTimeout(function () {
              if (getSentinel() && getNextUrl()) {
                hidePagination();
                resetRequired = false;
                clearTimeout(resetFallback);
                checkScroll();
              }
            }, 300);
            break;
          }
        }
      }).observe(container, { childList: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
